import { BlockActionType } from '@core/enums';
import { MixedObject } from '@core/interfaces/mixed-object';
import { Style, Styles } from '@core/interfaces/styles/styles.interface';
import { Block } from '@core/models/block/block.model';

export const isSpecialBlock = (item: Block): boolean => {
  return !!item.specialBlockId && item.specialBlockId > 0 && !!item.specialBlock;
};

export const mergeAllStyles = (
  styles: Styles,
  query: string,
): Record<string, any> => {
  styles = styles || {};
  const mergedStyle = {basic: {}, hover: {}, active: {}, scrolled: {}};
  for (const _style of Object.keys(styles)) {
    mergedStyle.basic = {
      ...mergedStyle.basic,
      ...(styles[_style].basic || {}),
    };
    mergedStyle.hover = {
      ...mergedStyle.hover,
      ...(styles[_style].hover || {}),
    };
    mergedStyle.active = {
      ...mergedStyle.active,
      ...(styles[_style].active || {}),
    };
    mergedStyle.scrolled = {
      ...mergedStyle.scrolled,
      ...(styles[_style].scrolled || {}),
    };


    if (_style === query) {
      break;
    }
  }
  return mergedStyle;
};

export const getStyles = (
  styles: Styles,
  query: string,
): MixedObject => {
  styles = styles || {};
  const fixedStyles = {basic: {}, hover: {}, active: {}};
  const mediaKeys = Object.getOwnPropertyNames(styles);
  for (const mqKey of mediaKeys) {
    if (mqKey === query && !Array.isArray(styles[mqKey])) {
      return Object.assign({...fixedStyles}, {...styles[mqKey]});
    }
  }
  const value = styles[mediaKeys[0]];
  if (Array.isArray(value) || typeof value !== 'object' || value === null) {
    return {basic: {}, hover: {}, active: {}};
  }
  return Object.assign({...fixedStyles}, {...value});
};

export const sortMediaQueries = (styles: Styles | null): Styles => {
  if (!styles) {
    return styles;
  }
  const mediaKeys = Object.getOwnPropertyNames(styles);
  const hasAllProp = mediaKeys.includes('all');
  const tmpKeys = mediaKeys.filter((prop) => prop !== 'all');

  let sorted = tmpKeys.sort((a, b) => {
    const numA = +a.replace(/\D+/g, '');
    const numB = +b.replace(/\D+/g, '');
    return numB - numA;
  });
  if (hasAllProp) {
    sorted = ['all', ...sorted];
  }
  const sortedStyles = {};
  sorted.forEach((key) => {
    sortedStyles[key] = styles[key];
  });
  return sortedStyles;
};

export const filterStyles = (styles: Styles | null, callback: (prop: string, val: string) => boolean): Styles => {
  if (!styles) {
    return styles;
  }

  const mediaKeys = Object.getOwnPropertyNames(styles);
  const s: Styles = {};
  mediaKeys.forEach(media => {
    s[media] = {};
    Object.keys(styles[media]).forEach(state => {
      s[media][state] = {};
      Object.keys(styles[media][state]).forEach(property => {
        if (callback(property, styles[media][state][property])) {
          s[media][state][property] = styles[media][state][property];
        }
      });
    });
  });

  return s;
};
export const appendToStyles = (styles: Styles | null, additionalStyles: Style): Styles => {
  if (!styles) {
    return {
      all: {
        basic: additionalStyles,
      },
    };
  }

  const mediaKeys = Object.getOwnPropertyNames(styles);
  const s: Styles = {};
  mediaKeys.forEach(media => {
    s[media] = {};
    Object.keys(styles[media]).forEach(state => {
      s[media][state] = {
        ...styles[media][state],
        ...additionalStyles,
      };
    });
  });

  return s;
};
export const findFirstBySettingsKey = (
  block: Block,
  key: string,
  value: string,
): Block | undefined => {
  if (block.children) {
    for (const blk of block.children) {
      if (blk.settings[key] === value) {
        return blk;
      } else if (blk.children) {
        const b: Block = findFirstBySettingsKey(blk, key, value);

        if (!b) {
          continue;
        }

        return b;
      }
    }
  }
};

export const findFirstByActionTypeAndData = (
  block: Block,
  actionType: BlockActionType,
  actionDataKey: string,
  actionDataValue: string,
): Block | undefined => {
  if (block.children) {
    for (const blk of block.children) {
      if (blk.action?.actionType === actionType && blk.action?.actionData[actionDataKey] === actionDataValue) {
        return blk;
      } else if (blk.children) {
        const b: Block = findFirstByActionTypeAndData(blk, actionType, actionDataKey, actionDataValue);

        if (!b) {
          continue;
        }

        return b;
      }
    }
  }
};

export const findAllByActionType = (
  block: Block,
  actionType: BlockActionType,
): Block[] => {
  const blocks: Block[] = [];
  if (block.children) {
    for (const blk of block.children) {
      if (blk.action?.actionType === actionType) {
        blocks.push(blk);
      } else if (blk.children) {
        const b: Block[] = findAllByActionType(blk, actionType);

        if (!b) {
          continue;
        }

        blocks.push(...b);
      }
    }
  }
  return blocks;
};
